import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getResaleItems, mapApiResaleItemToResaleItem, resaleItemsQueryKeys } from '@api/resaleItems';
import { ApiError } from '@api/client';
import type { ResaleItemsListParams } from '@api/resaleItems';

interface UseResaleItemsOptions {
  enabled?: boolean;
}

export function useResaleItems(params?: ResaleItemsListParams, { enabled = true }: UseResaleItemsOptions = {}) {
  return useQuery({
    queryKey: resaleItemsQueryKeys.list(params),
    queryFn: () => getResaleItems(params),
    staleTime: 30_000,
    placeholderData: keepPreviousData,
    enabled,
    select: (data) => ({
      resaleItems: data.resale_items.map(mapApiResaleItemToResaleItem),
      pagination: data.pagination,
      totalUnfiltered: data.total_unfiltered,
    }),
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
